<h4 class="q-form-group-heading">
  <ng-content></ng-content>
</h4>
